module.exports = __webpack_public_path__ + "static/media/CloudUpload.ff3d9348.svg";